import { determinePlan } from '../../common/institution/plan';
/**
 * Check whether this institution is an enterprise, defined as a Clinic
 * tier institution that has more than 50 seats
 */
export function isEnterprise(institution) {
    if (!Boolean(institution)) {
        console.debug(`Not an institution, returning false`);
        return false;
    }
    if (!institution.purchases || institution.purchases.length === 0) {
        console.debug(`Cannot determine if ${institution.name} is an enterprise because the purchase array was empty. Returning false.`);
        return false;
    }
    const lastPurchase = institution.purchases[0];
    const plan = determinePlan(lastPurchase.planId, lastPurchase.seats);
    return plan.type === 'enterprise';
}
